import { fetch, Method } from 'core/api/fetch';
import { DateTime } from 'luxon';

const TrafficRoutes = {
    getDashboard: (params) => `/api/v1.1.1/admin/analytics/dashboard?${params}`,
};

export const TrafficService = {
    getDashboard: async (options) => {
        try {
            const params = new URLSearchParams();

            if (options?.filters) {
                const { startDate, endDate, timezone, contractIds } = options.filters;

                if (startDate) {
                    params.append('startDate', startDate.toISO?.() ?? startDate);
                }
                if (endDate) {
                    params.append('endDate', endDate.toISO?.() ?? endDate);
                }
                if (timezone) {
                    params.append('timezone', String(timezone));
                }
                if (Array.isArray(contractIds) && contractIds.length > 0) {
                    // Send as comma-separated string: contractIds=1,2,3
                    params.append('contractId', contractIds.join(','));
                }
            }

            const { data } = await fetch(TrafficRoutes.getDashboard(params.toString()), {
                method: Method.GET,
                authenticated: true,
            });

            return !data ? {} : data;
        } catch (err) {
            throw new Error(err);
        }
    },
};
